import{authTokenHandler as authTokenHandlerInternal}from"./authTokenHandler_DEPRECATED";export const authTokenHandler={...authTokenHandlerInternal};